import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});
    
export const automationCount = async() =>
    await instance.post("automation/count");

export const deviceList = async(house) =>
    await instance.post("automation/device/list",{house});

export const deviceStatus = async(id) =>
    await instance.post("automation/device/status",{id});
    
export const deviceToggle = async(id,userID) =>
    await instance.post("automation/device/toggle",{id,userID});

export const deviceOn = async(id,userID) =>
    await instance.post("automation/device/on",{id,userID});
    
export const deviceOff = async(id,userID) =>
    await instance.post("automation/device/off", {id,userID});

export const deviceTimer = async(id) =>
    await instance.post("automation/device/timer/status", {id});

export const deviceTimerStart = async(id,time) =>
    await instance.post("automation/device/timer/start", {id,time});

export const deviceTimerEnd = async(id,time) =>
    await instance.post("automation/device/timer/end", {id,time});

export const deviceAdd = async(id,name,type,house,brand) =>
    await instance.post("automation/device/add", {id,name,type,house,brand});

export const allDoorDevicesSelect = async() =>
    await instance.post('automation/door/select/all')
    
export const newDoorAccessRule = async(empId, deviceId, startTime, endTime) =>
    await instance.post('automation/door/rule/new',{empId, deviceId, startTime, endTime})